import { createContext } from 'react';

export const ManageContactContext = createContext(null);
